import { useActiveClinic } from '@/lib/ActiveClinicContext';
import { useClinic } from './useClinicSettings';
import type { Database } from '@/types/database.generated';

type ClinicType = Database['public']['Enums']['clinic_type'];

export function useClinicType() {
  const { activeClinicId } = useActiveClinic();
  const { data: clinic, isLoading } = useClinic(activeClinicId);
  
  const type = clinic?.type as ClinicType | null;
  
  return {
    type,
    isLoading,
    isDentist: type === 'dentist',
    isPsychologist: type === 'psychologist',
    isSpecialist: type === 'specialist',
    isEmdrTherapist: type === 'emdr_therapist',
  };
}
